import React, { useId, useState } from "react";
import "../../css/designSystem/FAQ.css";

const FAQ = ({ items = [], defaultOpenIndex = null }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);
  const idPrefix = useId();

  const toggleItem = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <div className="column gap-l">
      {items.map(({ question, answer }, index) => {
        const isOpen = openIndex === index;
        const buttonId = `${idPrefix}-button-${index}`;
        const panelId = `${idPrefix}-panel-${index}`;

        return (
          <div
            className={`faq-item${isOpen ? " is-open" : ""} py-m px-xl bg-white all-radius-l column gap-m flex-start`}
            key={question}
          >
            <div
              id={buttonId}
              className="faq-question gap-m bg-transparent"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => toggleItem(index)}
            >
              <span className="subtitle-semibold text-gray-1 text-left">{question}</span>
              <span className="faq-icon" aria-hidden="true" />
            </div>

            <div
              id={panelId}
              className="faq-answer-wrapper "
              role="region"
              aria-labelledby={buttonId}
            >
              <div className="faq-answer">
                <div className="content text-gray-1 text-left">{answer}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQ;
